import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const BeraChainLogoCircle = t0 => {
  const $ = _c(17);
  let className;
  let rest;
  let square;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      square,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = square;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    square = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[5] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = square ? 0 : 12;
  let t4;
  if ($[7] !== t3) {
    t4 = <rect fill="#451D07" height={24} rx={t3} width={24} />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M11.552 11.392a.843.843 0 0 1-.03-.122 2.763 2.763 0 0 0-.043-.18h.001c.187-.272 1.082-1.695.064-2.609-1.13-1.014-2.45.315-2.45.315l.004.006a3.263 3.263 0 0 0-1.862-.006c-.008-.008-1.324-1.326-2.45-.315-1.127 1.011.09 2.647.096 2.656a.793.793 0 0 0-.03.117c-.122.7-.952.916-.952 2.136 0 1.22.868 2.222 2.64 2.222h.727c.004.005.303.413.918.413.57 0 .947-.41.95-.413h.694c1.772 0 2.64-.98 2.64-2.222 0-1.136-.72-1.401-.916-1.998h-.001ZM20.021 10s.131-1.175-.87-1.428v-.47h-.776v.459c-1.057.225-.92 1.44-.92 1.44v.2s-.137 1.215.92 1.44v1.01c-1.114.194-.973 1.449-.973 1.449v.201s-.136 1.215.92 1.44v.46h.776v-.472c1.002-.253.87-1.428.87-1.428.044 0 .08-.034.08-.076v-.049a.078.078 0 0 0-.08-.076s.131-1.165-.857-1.425V11.64H19.1c1.057-.225.92-1.44.92-1.44.044 0 .08-.034.08-.076v-.049a.078.078 0 0 0-.08-.076l.001.001Zm-.632 4.1h-.071a.078.078 0 0 0-.08.076v.049c0 .042.036.076.08.076h.07c0 .73-.25.852-.335.873-.014.003-.028-.007-.028-.02v-.233c0-.129-.085-.199-.17-.237a.416.416 0 0 0-.34 0c-.085.038-.17.108-.17.237v.232a.022.022 0 0 1-.027.02c-.084-.02-.336-.141-.336-.872V14.1c0-.73.251-.852.336-.873.014-.003.027.007.027.02v.233c0 .129.085.199.17.237a.417.417 0 0 0 .34 0c.085-.038.17-.108.17-.237v-.232a.02.02 0 0 1 .027-.02c.084.02.337.141.337.872Zm-.02-3.898h.072c0 .73-.252.852-.337.872a.022.022 0 0 1-.027-.02v-.233c0-.128-.084-.199-.17-.237a.417.417 0 0 0-.34 0c-.084.038-.17.109-.17.237v.233c0 .013-.013.023-.027.02-.084-.02-.336-.143-.336-.872V10c0-.73.253-.852.337-.872a.022.022 0 0 1 .027.02v.233c0 .128.085.198.17.237a.416.416 0 0 0 .34 0c.085-.039.17-.109.17-.237v-.233a.02.02 0 0 1 .027-.02c.084.02.336.143.336.872h-.071a.078.078 0 0 0-.08.076v.05c0 .041.036.076.08.076h-.001Zm-3.23 1.874s.136-1.222-.93-1.442V9.536c1.038-.235.903-1.436.903-1.436h-.58c0 .73-.252.852-.336.872a.022.022 0 0 1-.027-.02V8.72c0-.129-.085-.2-.17-.237a.416.416 0 0 0-.34 0c-.085.038-.17.108-.17.237v.232a.02.02 0 0 1-.027.02c-.085-.02-.336-.143-.336-.872h-.58s-.14 1.247.963 1.448v1.084c-1.074.216-.937 1.442-.937 1.442v.202s-.137 1.227.937 1.443v1.033c-1.103.201-.963 1.448-.963 1.448h.58c0-.73.252-.852.336-.872a.022.022 0 0 1 .027.02v.232c0 .129.085.2.17.237a.417.417 0 0 0 .34 0c.085-.038.17-.108.17-.237v-.232c0-.014.014-.024.028-.02.084.02.335.143.335.872h.58s.135-1.201-.903-1.436v-1.047c1.066-.22.93-1.441.93-1.441a.078.078 0 0 0 .079-.076v-.05a.078.078 0 0 0-.08-.076l.001.002Zm-.651.201h.07c0 .73-.252.852-.336.872a.022.022 0 0 1-.027-.02v-.232c0-.129-.085-.2-.17-.238a.417.417 0 0 0-.34 0c-.085.039-.17.11-.17.238v.232a.02.02 0 0 1-.027.02c-.085-.02-.336-.143-.336-.872v-.201c0-.73.252-.853.336-.873a.022.022 0 0 1 .027.02v.233c0 .128.085.199.17.237a.416.416 0 0 0 .34 0c.085-.038.17-.109.17-.237v-.232c0-.014.014-.024.028-.02.084.02.336.143.336.872h-.071a.078.078 0 0 0-.08.076v.049c0 .042.036.076.08.076Z" fill="#DEB69A" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <g fill="none" fillRule="nonzero">{t4}{t5}</g>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== className || $[13] !== rest || $[14] !== t2 || $[15] !== t6) {
    t7 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[12] = className;
    $[13] = rest;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export const BeraChainLogoCircleMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm7.151 8.102h-.776v.459c-1.007.214-.93 1.327-.92 1.432v.208s-.137 1.215.92 1.44v1.01c-1.063.185-.983 1.337-.974 1.441l.001.209s-.136 1.215.92 1.44v.46h.776v-.472c1.002-.253.87-1.428.87-1.428.044 0 .08-.034.08-.076v-.049a.078.078 0 0 0-.08-.076s.131-1.165-.857-1.425V11.64H19.1c1.057-.225.92-1.44.92-1.44.044 0 .08-.034.08-.076v-.049c0-.02-.01-.04-.024-.055l-.026-.016-.03-.006c.011-.113.082-1.186-.869-1.426v-.47ZM14.126 8.1h-.58s-.14 1.247.963 1.448v1.084c-1.074.216-.937 1.442-.937 1.442v.202s-.137 1.227.937 1.443v1.033c-1.103.201-.963 1.448-.963 1.448h.58c0-.73.252-.852.336-.872a.022.022 0 0 1 .027.02v.232c0 .129.085.2.17.237a.417.417 0 0 0 .34 0c.085-.038.17-.108.17-.237v-.232c0-.014.014-.024.028-.02.084.02.335.143.335.872h.58s.135-1.201-.903-1.436v-1.047c1.066-.22.93-1.441.93-1.441a.078.078 0 0 0 .079-.076v-.05c0-.02-.01-.04-.024-.055l-.026-.016-.029-.006c.01-.111.085-1.23-.93-1.439V9.536c1.038-.235.903-1.436.903-1.436h-.58c0 .73-.252.852-.336.872a.022.022 0 0 1-.027-.02V8.72c0-.129-.085-.2-.17-.237a.416.416 0 0 0-.34 0c-.085.038-.17.108-.17.237v.232a.02.02 0 0 1-.027.02c-.085-.02-.336-.143-.336-.872Zm-9.34.381c-1.127 1.011.09 2.647.096 2.656a.793.793 0 0 0-.03.117c-.122.7-.952.916-.952 2.136 0 1.22.868 2.222 2.64 2.222h.727c.004.005.303.413.918.413.475 0 .816-.285.918-.381l.032-.032h.694c1.772 0 2.64-.98 2.64-2.222 0-1.136-.72-1.401-.916-1.998a.733.733 0 0 1-.031-.122l-.02-.09-.022-.09c.187-.272 1.082-1.695.064-2.609-1.05-.942-2.262.137-2.43.296l-.02.019a3.302 3.302 0 0 0-1.858 0c-.008-.008-1.324-1.326-2.45-.315Zm13.559 4.766v.233c0 .129.085.199.17.237a.417.417 0 0 0 .34 0c.085-.038.17-.108.17-.237v-.232a.02.02 0 0 1 .027-.02c.084.02.337.141.337.872h-.071a.078.078 0 0 0-.08.076v.049c0 .042.036.076.08.076h.07c0 .73-.25.852-.335.873-.014.003-.028-.007-.028-.02v-.233c0-.129-.085-.199-.17-.237a.416.416 0 0 0-.34 0c-.085.038-.17.108-.17.237v.232a.022.022 0 0 1-.027.02c-.084-.02-.336-.141-.336-.872V14.1c0-.73.251-.852.336-.873.014-.003.027.007.027.02Zm-3.839-2.04c.005.004.009.01.009.016v.233c0 .128.085.199.17.237a.416.416 0 0 0 .34 0c.085-.038.17-.109.17-.237v-.232c0-.014.014-.024.028-.02.084.02.336.143.336.872h-.071a.078.078 0 0 0-.08.076v.049c0 .042.036.076.08.076h.07c0 .73-.252.852-.336.872a.022.022 0 0 1-.027-.02v-.232c0-.129-.085-.2-.17-.238a.417.417 0 0 0-.34 0c-.085.039-.17.11-.17.238v.232a.02.02 0 0 1-.027.02c-.085-.02-.336-.143-.336-.872v-.201c0-.73.252-.853.336-.873a.022.022 0 0 1 .018.004Zm3.883-2.075c.005.004.009.01.009.016v.233c0 .128.085.198.17.237a.416.416 0 0 0 .34 0c.085-.039.17-.109.17-.237v-.233a.02.02 0 0 1 .027-.02c.084.02.336.143.336.872h-.071a.078.078 0 0 0-.08.076v.05c0 .041.036.076.08.076h.071c0 .73-.252.852-.337.872a.022.022 0 0 1-.027-.02v-.233c0-.128-.084-.199-.17-.237a.417.417 0 0 0-.34 0c-.084.038-.17.109-.17.237v.233c0 .013-.013.023-.027.02-.084-.02-.336-.143-.336-.872V10c0-.73.253-.852.337-.872a.022.022 0 0 1 .018.004Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};